/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matches_TitleInputs */

const cs_matches_title = /** @type {(inputs: Matches_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Párování poptávek`)
};

const en_matches_title = /** @type {(inputs: Matches_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demand matching`)
};

/**
* | output |
* | --- |
* | "Demand matching" |
*
* @param {Matches_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const matches_title = /** @type {((inputs?: Matches_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matches_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_matches_title(inputs)
	return cs_matches_title(inputs)
});